const ENDPOINT = "https://altitudes.leftcape.com/ip";

export async function fetchBrokerIp(fallback) {
  try {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 5000);
    const response = await fetch(ENDPOINT, { signal: controller.signal });
    clearTimeout(timeout);

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    const data = await response.json();
    const ip = typeof data?.ip === "string" ? data.ip.trim() : "";
    if (!ip) {
      throw new Error("Campo 'ip' vacío o ausente");
    }

    return ip;
  } catch (error) {
    console.warn(`No se pudo obtener IP del broker desde ${ENDPOINT}:`, error);
    return fallback;
  }
}
